import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { reviewId: String, url: String }

  connect() {
    this.isVisible = false
  }

  toggle(event) {
    event.preventDefault()

    const repliesFrame = document.getElementById(`review_replies_${this.reviewIdValue}`)

    if (!repliesFrame) {
      return
    }

    if (this.isVisible) {
      // Hide replies
      repliesFrame.innerHTML = ""
      this.isVisible = false
    } else {
      // Show replies - fetch and insert content
      fetch(this.urlValue, {
        headers: {
          'Accept': 'text/html',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`)
        }
        return response.text()
      })
      .then(html => {
        repliesFrame.innerHTML = html
        this.isVisible = true
      })
      .catch(error => {
        repliesFrame.innerHTML = '<div class="text-red-400 p-3">Error loading replies</div>'
      })
    }
  }
}